<script lang="ts">
  let {
    element,
    event,
    onReady,
  } = $props<{
    element: string | HTMLElement;
    event: CustomEvent;
    onReady: (el: HTMLElement) => void;
  }>();

  if (typeof element === "string") {
    const constructor = customElements.get(element);
    if (constructor) {
      element = new constructor();
    } else {
      const html = element;
      element = document.createElement("div");
      element.innerHTML = html;
    }
  }

  let container = $state<HTMLElement>();
  $effect(() => {
    container.appendChild(element);
    setTimeout(() => {
      element.dispatchEvent(event);
      onReady(element);
    });
  });
</script>

<div bind:this={container} on:mt-component-update></div>
